import { forwardRef } from 'react';
import PropTypes from 'prop-types';
import './Input.css';

const Input = forwardRef(({
    label,
    type = 'text',
    error,
    helperText,
    icon: Icon,
    iconPosition = 'left',
    fullWidth = true,
    className = '',
    required = false,
    disabled = false,
    ...props
}, ref) => {
    const inputId = props.id || props.name || `input-${Math.random().toString(36).substr(2, 9)}`;

    return (
        <div className={`input-wrapper ${fullWidth ? 'input-full' : ''} ${className}`}>
            {label && (
                <label htmlFor={inputId} className="input-label">
                    {label}
                    {required && <span className="input-required">*</span>}
                </label>
            )}
            <div className={`input-container ${Icon ? 'has-icon' : ''} ${iconPosition}`}>
                {Icon && <Icon size={18} className="input-icon" />}
                <input
                    ref={ref}
                    id={inputId}
                    type={type}
                    className={`input ${error ? 'input-error' : ''}`}
                    disabled={disabled}
                    {...props}
                />
            </div>
            {(error || helperText) && (
                <span className={`input-helper ${error ? 'error' : ''}`}>
                    {error || helperText}
                </span>
            )}
        </div>
    );
});

Input.displayName = 'Input';

Input.propTypes = {
    label: PropTypes.string,
    type: PropTypes.string,
    error: PropTypes.string,
    helperText: PropTypes.string,
    icon: PropTypes.elementType,
    iconPosition: PropTypes.oneOf(['left', 'right']),
    fullWidth: PropTypes.bool,
    className: PropTypes.string,
    required: PropTypes.bool,
    disabled: PropTypes.bool,
    id: PropTypes.string,
    name: PropTypes.string
};

export default Input;
